import { Person } from "@/Common/Models/Person/Person";
import { DropdownItem } from "./DropdownItem";

class PersonDropdownItem extends DropdownItem<Person> { }

export { PersonDropdownItem };
